var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"addgallary"},[_c('div',[_c('div',{staticStyle:{"width":"100%","display":"flex","top":"0px"}},[_c('GDriveSelector',{attrs:{"ismulti":_vm.ismulti},on:{"selectImages":_vm.selectImages}})],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }